// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountV2PatientsSearchPatientsSearchPatientsResponse {
    static getAttributeTypeMap() {
        return SiteAccountV2PatientsSearchPatientsSearchPatientsResponse.attributeTypeMap;
    }
}
SiteAccountV2PatientsSearchPatientsSearchPatientsResponse.discriminator = undefined;
SiteAccountV2PatientsSearchPatientsSearchPatientsResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ScriptsSiteAccountV2PatientsPatientAccountModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=siteAccountV2PatientsSearchPatientsSearchPatientsResponse.js.map